export enum BasicReportItemTypeEnum {
    SESSION = 'SESSION',
    EVALUATION = 'EVALUATION'
}
